// extracted by mini-css-extract-plugin
export default {"body":"TermsSummary_body__QvbCa","text":"TermsSummary_text__+SD+E"};